export const JHD_LAYOUT_TAG_NAME = 'jhd-layout';
